module.exports = {
  domain: {
    desktop: "pabets.prd.use2.racing.fndlext.net",
    mobile: "pabets.prd.use2.racing.fndlext.net",
    talentPicks: "pabets.prd.use2.racing.fndlext.net/talent-picks/",
    equibase: "equibase-store.tvg.com"
  },
  recaptchaID: "6LdrNBgqAAAAAKKs_ZP23RQvTYPkSFdZQ9KK_j6K",
  recaptchaIdNative: "6LfSQloqAAAAAFKuurdHLnObQ-r2CGo0TuuYdNq-"
};
